import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OngoingControlSummary } from 'src/app/control/model/control.model';
import { fetchOngoingControlSummaries } from 'src/app/control/store/control.action';
import { selectOngoingControlSummaries } from 'src/app/control/store/control.selector';
import { TranslocoDirective } from '@jsverse/transloco';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { TertiaryButtonComponent } from '../../shared/buttons/tertiary-button.component';
import { AsyncPipe, DatePipe } from '@angular/common';

export const ONGOING_CONTROLS_TOP_COUNT = 5;

@Component({
  selector: 'sibat-ongoing-building-controls-widget',
  templateUrl: 'ongoing-building-controls-widget.component.html',
  styleUrls: ['ongoing-building-controls-widget.component.scss'],
  imports: [
    TranslocoDirective,
    WidgetComponent,
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    TertiaryButtonComponent,
    AsyncPipe,
    DatePipe,
  ],
})
export class OngoingBuildingControlsWidgetComponent implements OnInit {
  displayedColumns: string[] = ['buildingId', 'egids', 'address', 'municipality', 'controlDate'];

  readonly showAll$ = new BehaviorSubject<boolean>(false);

  readonly displayedSummaries$: Observable<OngoingControlSummary[]>;

  readonly hasMoreThanTop$: Observable<boolean>;

  readonly isEmpty$: Observable<boolean>;

  private readonly summaries$: Observable<OngoingControlSummary[]>;

  constructor(private store: Store, private router: Router) {
    this.summaries$ = this.store.select(selectOngoingControlSummaries);

    this.displayedSummaries$ = combineLatest([this.summaries$, this.showAll$]).pipe(
      map(([summaries, showAll]) => (showAll ? summaries : summaries.slice(0, ONGOING_CONTROLS_TOP_COUNT)))
    );
    this.hasMoreThanTop$ = this.summaries$.pipe(map(summaries => summaries.length > ONGOING_CONTROLS_TOP_COUNT));
    this.isEmpty$ = this.summaries$.pipe(map(summaries => summaries.length === 0));
  }

  ngOnInit(): void {
    this.store.dispatch(fetchOngoingControlSummaries());
  }

  toggleShowAll(): void {
    this.showAll$.next(!this.showAll$.value);
  }

  displayBuilding(buildingId: number): void {
    this.router.navigate([`/building/${buildingId}`]);
  }
}
